import React, { ReactElement } from 'react';
import styled from 'styled-components';

import { Flex, Box } from 'components/flex';

type SwitchColors = 'green' | 'red' | 'gray';

interface SwitchProps {
  checked?: boolean;
  color?: SwitchColors;
  onClick?: () => void;
}

interface SwitchStyleProps {
  checked: boolean;
  color: SwitchColors;
}

const Button = styled(Box)`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.24);
  cursor: pointer;
  transition: 0.2s;
`;

const Track = styled(Box)`
  width: 34px;
  height: 14px;
  background: ${({ theme }) => theme.colors.primary_400};
  border-radius: 7px;
  position: absolute;
  top: 3px;
  left: 3px;
`;

const Wrapper = styled(Flex)<SwitchStyleProps>`
  position: relative;
  width: 40px;
  height: 20px;

  ${Button} {
    background: ${({ theme, color, checked }) => {
      switch (color) {
        case 'green':
          return theme.colors.primary_200;

        case 'red':
          return theme.colors.alert_400;

        default:
          return theme.colors.gray_500;
      }
    }};

    ${({ checked }) => {
      return checked ? `right: 0` : `left: 0;`;
    }};
  }

  ${Track} {
    background: ${({ theme, color, checked }) => {
      switch (color) {
        case 'green':
          return theme.colors.primary_400;

        case 'red':
          return theme.colors.alert_600;

        default:
          return theme.colors.gray_300;
      }
    }};
  }
`;

const Switch = ({ checked, color, onClick }: SwitchProps): ReactElement => {
  const switchColor = color || 'gray';

  return (
    <Wrapper checked={!!checked} color={switchColor}>
      <Button onClick={onClick} />
      <Track />
    </Wrapper>
  );
};
export default Switch;
